export const SURVEY_SCORE_MIN_VALUE = {
  DANGER: 0,
  WARNING: 50,
  SUCCESS: 75,
};

export type SurveyScoreGroupKey = 'GREEN' | 'YELLOW' | 'RED';

export interface SurveyScoreGroup {
  color: 'success' | 'warning' | 'danger';
  description: string;
  minValue: number;
  title: string;
}

export const SURVEY_SCORE_GROUPS: Record<
  SurveyScoreGroupKey,
  SurveyScoreGroup
> = {
  GREEN: {
    color: 'success',
    minValue: SURVEY_SCORE_MIN_VALUE.SUCCESS,
    title: 'High Attractiveness',
    description:
      'Your project displays exceptional attractiveness and potential compared to the current PureSpectrum marketplace survey inventory. Please note that as marketplace inventory changes, this score will change over time.',
  },
  YELLOW: {
    color: 'warning',
    minValue: SURVEY_SCORE_MIN_VALUE.WARNING,
    title: 'Developing',
    description:
      'Your project displays average attractiveness compared to the current PureSpectrum marketplace survey inventory. For this project to rank higher we recommend a price closer to our data-driven PurePrice: <PUREPRICE>. Please note that as marketplace inventory changes, this score will change over time.',
  },
  RED: {
    color: 'danger',
    minValue: SURVEY_SCORE_MIN_VALUE.DANGER,
    title: 'Needs Improvement',
    description:
      "Your project displays lower than average attractiveness compared to the current PureSpectrum marketplace survey inventory. For this project to rank higher we recommend a price closer to our data-driven PurePrice: <PUREPRICE> and to review your survey's targeting, LOI, and IR. Please note that as marketplace inventory changes, this score will change over time.",
  },
};
